import React from 'react';
import BasicInfoItem from './BasicInfoItem';
import { WeddingWebsiteQuery } from '../../generated/graphql';
import CoverPhoto from './CoverPhoto';
import { Page } from '../PageCard';
import PageCardItems from '../PageCard/PageCardItems';
import AddToPageButton from '../PageCard/AddToPageButton';
import styles from './verticalCoverPhoto.scss';
import { Body2, Caption } from '@xo-union/tk-ui-typography';
import Loading from '../../Loading';

interface Props {
  page: Page;
  weddingDateText: string;
  data?: WeddingWebsiteQuery;
  screenshot?: string;
}

// const previewUrlBase = 'http://qa-dev.theknot.com:3001';
const previewUrlBase = process.env.REACT_APP_PREVIEW_URL_BASE || '';
const IFRAME_SIZE = 1440;

const VerticalCoverPhoto: React.FC<Props> = ({ page, data, weddingDateText }) => {
  const [loading, setLoading] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const [scale, setScale] = React.useState(1);
  const previewUrl = `${previewUrlBase}/us/${data?.weddingWebsite?.slug}`;

  React.useEffect(() => {
    const updateScale = () => {
      if (wrapperRef.current) {
        const wrapperWidth = wrapperRef.current.offsetWidth;
        const newScale = wrapperWidth / IFRAME_SIZE;
        setScale(newScale);
      }
    };

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, []);

  React.useEffect(() => {
    if (loading) {
      // hack to trigger reload of iframe with new cover photo
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [loading, setLoading]);

  if (data?.weddingWebsite.coverPhoto?.mediaUrl) {
    return (
      <>
        <div className={styles.container}>
          <div className={styles.leftColumn}>
            <div
              className={styles.iframeWrapper}
              style={loading ? { display: 'none' } : { display: 'block' }}
              ref={wrapperRef}
            >
              <iframe
                id="snapshot-iframe"
                title="snapshot-preview-iframe"
                src={previewUrl}
                className={styles.iframePreview}
                style={{ transform: `scale(${scale})`, pointerEvents: 'none' }}
                scrolling="no"
                onLoad={() => setLoading(false)}
              />
            </div>
            {loading ? (
              <div className={styles.loadingContainer}>
                <Body2>Generating preview</Body2>
                <Loading className={styles.loading} />
              </div>
            ) : null}
          </div>
          <div className={styles.rightColumn}>
            <CoverPhoto pageId={page.id} onSave={() => setLoading(true)} />
            <div className={styles.basicInfoItem}>
              <Caption as="h4" className={styles.basicInfoTitle}>
                Basic info
              </Caption>
              <BasicInfoItem data={data} weddingDateText={weddingDateText} as="h3" showExperiment />
            </div>
          </div>
        </div>
        <PageCardItems page={page} />
        <AddToPageButton page={page} />
      </>
    );
  } else {
    return <CoverPhoto pageId={page.id} />;
  }
};

export default VerticalCoverPhoto;
